import styles from "./controlPanel.module.scss";

export const ControlPanel = ({
  className,
  left,
  right,
}: {
  className?: string;
  left?: React.ReactNode;
  right?: React.ReactNode;
}) => {
  return (
    <div className={`${styles["control-panel"]} ${className ? className : ""}`}>
      <div className={styles["left"]}>{left}</div>
      <div className={styles["right"]}>{right}</div>
    </div>
  );
};
